import './index.css';
import moment from 'moment';
import 'moment/locale/id';
import { createRoot } from 'react-dom/client';
import App from './App';
import './locale/i18n';
import reportWebVitals from './reportWebVitals';

moment.locale('en-EN');

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
